type Translate = (
  key: string,
  values?: Record<string, string | number>,
) => string

const routeLabels: Record<string, string> = {
  home: 'Home',
  notes: 'Notes',
  memories: 'Memories',
  'to-dos': 'To-Dos',
  ideas: 'Ideas',
  links: 'Links',
  recipes: 'Recipes',
  movies: 'Movies',
  locations: 'Locations',
  trips: 'Trips',
  protocols: 'Protocols',
  objectives: 'Objectives',
  objective: 'Objective',
  events: 'Events',
  translation: 'Translation',
  whiteboards: 'Whiteboards',
  files: 'Files',
  scenarios: 'Scenarios',
  settings: 'Settings',
  purchases: 'Purchases',
  search: 'Search',
  information: 'Information',
  wedding: 'Wedding',
}

const searchTypeLabels: Record<string, string> = {
  all: 'All',
  memory: 'Memories',
  todo: 'To-Dos',
  idea: 'Ideas',
  link: 'Links',
  event: 'Events',
  whiteboard: 'Whiteboards',
  vocabulary: 'Vocabulary',
  recipe: 'Recipes',
  movie: 'Movies',
  location: 'Locations',
  objective: 'Objectives',
  file: 'Files',
  protocol: 'Protocols',
}

const fallbackTitle = (value: string) =>
  value
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')

export const getRouteTitle = (pathname: string, t: Translate) => {
  const parts = pathname.replaceAll('%20', ' ').split('/').filter(Boolean)

  if (!parts.length) {
    return t(routeLabels.home)
  }

  const primarySegment = parts[0]
  const secondarySegment = parts[1]

  if (primarySegment === 'notes' && secondarySegment) {
    return t(routeLabels[secondarySegment] || routeLabels.notes)
  }

  return t(routeLabels[primarySegment] || fallbackTitle(primarySegment))
}

export const getDocumentTitle = (pathname: string, t: Translate) => {
  const pageTitle = getRouteTitle(pathname, t)
  const appName = t('appName')

  return pageTitle === t('Home') ? appName : `${pageTitle} | ${appName}`
}

export const getSearchTypeLabel = (type: string, t: Translate) =>
  t(searchTypeLabels[type] || fallbackTitle(type))
